import { useSelector } from 'react-redux';

/**
 * What the signed-in account is allowed to do.
 *
 * The list arrives from the API with the account and is stored, for the reasons in
 * `auth/store/userSlice`, in the slot Fuse calls `role` — it is what every route guard
 * and navigation item in `@fuse/` already reads, so nothing in the vendor tree had to
 * change to understand permissions.
 *
 * Two shapes, because both read well at a call site:
 *
 *   const can = usePermission();          // can('users.edit.all')
 *   const canEdit = usePermission('users.edit.all');
 *
 * Asked for several, it means **all** of them. A screen that wants "any of these"
 * should ask twice and combine the answers, which is clearer than a flag.
 */
const usePermission = (...permissions) => {
  const held = useSelector(state => state.auth.user.role) || [];

  const can = (...wanted) =>
    wanted.length > 0 && wanted.every(permission => held.includes(permission));

  return permissions.length ? can(...permissions) : can;
};

export default usePermission;
